import { render, staticRenderFns } from "./pledge.vue?vue&type=template&id=21d60b81&"
import script from "./pledge.vue?vue&type=script&lang=js&"
export * from "./pledge.vue?vue&type=script&lang=js&"
import style0 from "./pledge.vue?vue&type=style&index=0&id=21d60b81&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports